module.exports = __webpack_public_path__ + "img/evisa-icon2.42788f71.png";